import { render, staticRenderFns } from "./Musiques.vue?vue&type=template&id=0d435524"
import script from "./Musiques.vue?vue&type=script&lang=ts"
export * from "./Musiques.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports